import {
  CreateQualityControlModalComponent
} from "../components/modals/create-quality-control-modal/create-quality-control-modal.component";
import {
  QualityControlApprovalsModalComponent
} from "../components/modals/quality-control-approvals-modal/quality-control-approvals-modal.component";
import {ProductCardQualityControlConfig} from "../types/product-card-quality-control.types";

const fields = [
  'createQualityControl',
  'productCardQualityControlApprovals'
];

export const qualityControlModalConfig: Record<string, ProductCardQualityControlConfig> = {};

fields.forEach(fieldName => {
  qualityControlModalConfig[fieldName] = {
    component: fieldName === 'createQualityControl' ?
      CreateQualityControlModalComponent :
      QualityControlApprovalsModalComponent,
    fieldName,
    width: '500px'
  };
});
